import {
  changePersonAppearance,
  forgetLegacyAppearance,
  legacyBrowserAppearance,
  type PaigeAppearance,
} from '@paige/capturepoint';

type Store = Pick<Storage, 'getItem' | 'removeItem'>;

function browserStorage(): Store | undefined {
  try {
    return window.localStorage;
  } catch {
    return undefined;
  }
}

/** A person who has never chosen: no colour picked in either theme, tooltips on. */
const unchosen = (a: PaigeAppearance): boolean =>
  a.accent.light === null && a.accent.dark === null && a.tooltips;

/**
 * Until 2026-10-20 the workbench kept the accent and Show tooltips in each browser. The first time a person whose
 * server record says nothing yet signs in on a browser that kept a choice, that choice becomes theirs, and the
 * browser forgets it once it is saved. Someone who already chose keeps their choice; the browser's is forgotten.
 */
export async function adoptBrowserAppearance(
  server: PaigeAppearance,
  storage: Store | undefined = browserStorage(),
): Promise<void> {
  const kept = legacyBrowserAppearance(storage);
  if (!kept) return;
  if (unchosen(server)) {
    try {
      await changePersonAppearance((was) => ({
        accent: {
          light: kept.accent.light ?? was.accent.light,
          dark: kept.accent.dark ?? was.accent.dark,
        },
        tooltips: kept.tooltipsOff ? false : was.tooltips,
      }));
    } catch {
      return; // Not saved: the browser keeps it and the next sign-in tries again.
    }
  }
  forgetLegacyAppearance(storage);
}
